import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Components/HomePage/HomePage.jsx';
import LinkPage from './Components/LinkPage/LinkPage.jsx';
import LinkAdmin from './Components/LinkAdmin/LinkAdmin.jsx';
import SignIn from './Components/SignIn/SignIn.jsx';
import SignUp from './Components/SignUp/SignUp.jsx';
import Account from './Components/Account/Account.jsx';
import Dashboard from './Components/Dashboard/Dashboard.jsx';
import PrivateRoute from './utils/PrivateRoute.jsx';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword.jsx';
import Header from './Components/Header/Header.jsx';
import AlertBanner from './Components/AlertBanner/AlertBanner.jsx'

const App = () => {
    return (
        <div>
            <AlertBanner />
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="*" element={<Header />} />
                </Routes>
                <Routes>
                    <Route path="/page/:pageId" element={<LinkAdmin />} />
                    <Route path="/session/:sessionId" element={<LinkPage />} />
                    <Route path="/login" element={<SignIn />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route
                        path="/account"
                        element={
                            <PrivateRoute>
                                <Account />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </Router>
        </div>
    );
};

export default App;